import ObjectId from 'bson-objectid';
import { Button, Col, Input, Row, Text, TextEditor } from 'components';
import { Api, theme } from 'lib';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Image, Tags } from 'screens/Admin/components';

const imageSizes = ['big', 'med', 'small'];

const AddPartner = () => {
  const [name, setName] = useState(''),
    [description, setDescription] = useState(''),
    [mainImage, setMainImage] = useState(null),
    [secondaryImage, setSecondaryImage] = useState(null),
    [tags, setTags] = useState([]),
    isMobile = useSelector((state) => state.appState.isMobile),
    navigate = useNavigate();

  async function submit() {
    if (!name || !description || !tags.length || !mainImage || !secondaryImage) {
      return alert('All fields are required!');
    }

    const documentId = ObjectId().toString();

    let data = new FormData(),
      fileNames = [];

    data.append('name', name);
    data.append('tags', tags);
    data.append('description', description);
    data.append('documentId', documentId);

    mainImage.forEach((x, i) => {
      const fileName = `${documentId}-main-${imageSizes[i]}.jpeg`;
      fileNames.push(fileName);

      data.append('images[]', x, fileName);
    });

    secondaryImage.forEach((x, i) => {
      const fileName = `${documentId}-secondary-${imageSizes[i]}.jpeg`;
      fileNames.push(fileName);

      data.append('images[]', x, fileName);
    });

    data.append('fileNames', JSON.stringify(fileNames));

    const res = await Api.post('/admin/addPartner', data, 'addPartner');
    if (!res) return console.log('Something went wrong!');

    navigate('/admin/partners');
  }

  if (isMobile) {
    return (
      <Col center pad="20px" ht="100vh">
        <Text h1>Please visit this screen on a computer browser.</Text>
      </Col>
    );
  }

  return (
    <Col bg={theme.GREY_10} wid="100%">
      <Col bg={theme.GREY_10} ht="100%" wid="1140px" pad="50px 20px" center>
        <Col center>
          <Text size="30px" marg="0 0 50px" med>
            ADD PARTNER
          </Text>

          <Input
            onChange={({ target }) => setName(target.value)}
            value={name}
            marg="0 0 20px"
            placeholder="Name"
            admin
          />

          <Tags handleChange={(data) => setTags(data)} />

          <Row start marg="0 0 20px">
            <Col minWid="250px" marg="0 100px 0 0">
              <Text med size="22px">
                Main image
              </Text>

              <Image imgs={mainImage} setImgs={(data) => setMainImage(data)} />
            </Col>

            <Col minWid="250px">
              <Text med size="22px">
                Secondary image
              </Text>

              <Image imgs={secondaryImage} setImgs={(data) => setSecondaryImage(data)} />
            </Col>
          </Row>

          <TextEditor onChange={(val) => setDescription(val)} value={description} />

          <Col center>
            <Button text="Publish" website marg="20px 0 0" onClick={submit} action="addPartner" />
          </Col>
        </Col>
      </Col>
    </Col>
  );
};

export default AddPartner;
